import { faFacebook, faInstagram, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">All Global Consultancy Services</h3>
            <p className="text-gray-100 mb-6 leading-relaxed">
             Your ambition to live in the UK & (All Europe) deserves a dedicated partner. We don't just process applications. We partner in your dream. Let's achieve it together
            </p>
            <div className="flex space-x-4">
              <div className="bg-blue-100 p-2 rounded-lg cursor-pointer hover:scale-110 transition duration-300">
                  <a href="https://www.facebook.com/profile.php?id=61584452638133" target='blank'>
                <span className=" text-xl mx-1 text-blue-700 ">
                  <FontAwesomeIcon icon={faFacebook}/>
                  </span>
                  </a>
              </div>
              <div className="bg-blue-100 p-2 rounded-lg cursor-pointer hover:scale-110  transition duration-300">
                <a href='https://www.tiktok.com/@global.consultanc2?_r=1&_t=ZN-91mUqCrPiUQ'>
                <span className=" text-xl mx-1 text-black"><FontAwesomeIcon icon={faTiktok}/></span>
                </a>
              </div>
              <div className="bg-blue-100 p-2 rounded-lg cursor-pointer hover:scale-110  transition duration-300">
                <a href='https://www.instagram.com/all.globalconsultancy/' target='blank'>
                <span className="text-xl mx-1 text-pink-500"><FontAwesomeIcon icon={faInstagram}/></span>
                </a>
              </div>
              
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-100 hover:text-white transition duration-300">Home</Link></li>
              <li><Link to="/about" className="text-gray-100 hover:text-white transition duration-300">About</Link></li>
              <li><Link to="/services" className="text-gray-100 hover:text-white transition duration-300">Services</Link></li>
              <li><Link to="/countries" className="text-gray-100 hover:text-white transition duration-300">Countries</Link></li>
              <li><Link to="/contact" className="text-gray-100 hover:text-white transition duration-300">Contact</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg text-white font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3 text-gray-100">
              <p><FontAwesomeIcon icon={faLocationDot} className='me-2'/><a href="https://www.google.com/maps/search/?api=1&query=19+Fenham+Road+Newcastle+Upon+Tyne+NE4+5PB"
                 >
                  19 Fenham Road Newcastle <br/> Upon Tyne NE4 5PB
                </a></p>
              <p><FontAwesomeIcon icon={faEnvelope} className='me-2'/><a href="mailto:globalconsultancy3877@gmail.com">globalconsultancy3877@gmail.com</a></p>
              <p><FontAwesomeIcon icon={faPhone} className='me-2'/> <a href="tel:01912508966">0191 250 8966</a></p>
              <p><FontAwesomeIcon icon={faWhatsapp} className='me-2'/><a href="https://wa.me/447796592487" > 07796 592 487 </a></p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-white">
            © 2026 All Global Consultancy Services . All rights reserved. | Privacy Policy | Terms of Service
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;